// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentWithdrawDialog-ErrorContainer_cls1__YFFOr","cls2":"PaymentWithdrawDialog-ErrorContainer_cls2__oD1TY PaymentWithdrawDialog-ErrorContainer_cls1__YFFOr"};